// Generated by purs version 0.13.8
"use strict";
var Animation_Core = require("../Animation.Core/index.js");
var Animation_Util = require("../Animation.Util/index.js");
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_Free = require("../Control.Monad.Free/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Board = require("../Data.Board/index.js");
var Data_DateTime_Instant = require("../Data.DateTime.Instant/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Terrain = require("../Data.Terrain/index.js");
var Data_Time_Duration = require("../Data.Time.Duration/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Effect = require("../Effect/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var Extra_Prelude = require("../Extra.Prelude/index.js");
var Framework_Audio = require("../Framework.Audio/index.js");
var Framework_Direction = require("../Framework.Direction/index.js");
var Framework_UI = require("../Framework.UI/index.js");
var GameState = require("../GameState/index.js");
var Input = require("../Input/index.js");
var TargetBoard = (function () {
    function TargetBoard(value0) {
        this.value0 = value0;
    };
    TargetBoard.create = function (value0) {
        return new TargetBoard(value0);
    };
    return TargetBoard;
})();
var CenterPane = (function () {
    function CenterPane(value0) {
        this.value0 = value0;
    };
    CenterPane.create = function (value0) {
        return new CenterPane(value0);
    };
    return CenterPane;
})();
var PlayerBoard = (function () {
    function PlayerBoard(value0) {
        this.value0 = value0;
    };
    PlayerBoard.create = function (value0) {
        return new PlayerBoard(value0);
    };
    return PlayerBoard;
})();
var Other = (function () {
    function Other() {

    };
    Other.value = new Other();
    return Other;
})();
var RPEnemy = (function () {
    function RPEnemy(value0) {
        this.value0 = value0;
    };
    RPEnemy.create = function (value0) {
        return new RPEnemy(value0);
    };
    return RPEnemy;
})();
var RPItem = (function () {
    function RPItem(value0) {
        this.value0 = value0;
    };
    RPItem.create = function (value0) {
        return new RPItem(value0);
    };
    return RPItem;
})();
var RPTerrain = (function () {
    function RPTerrain(value0) {
        this.value0 = value0;
    };
    RPTerrain.create = function (value0) {
        return new RPTerrain(value0);
    };
    return RPTerrain;
})();
var RPNoTarget = (function () {
    function RPNoTarget() {

    };
    RPNoTarget.value = new RPNoTarget();
    return RPNoTarget;
})();
var UIState = function (x) {
    return x;
};
var verticalTiles = Extra_Math.toNumber(Extra_Math.realInt)(Data_Terrain.arena.height);
var toLockedTarget = function (t) {
    return function (v) {
        return {
            rightPaneTarget: v.lockedTarget,
            lockedTarget: v.lockedTarget,
            itemTarget: v.itemTarget,
            timestamp: t,
            gsTimestamp: v.gsTimestamp,
            playerAnim: v.playerAnim,
            enemyAnim: v.enemyAnim,
            itemAnim: v.itemAnim,
            highlights: v.highlights,
            audioData: v.audioData,
            audioQueue: v.audioQueue,
            draggingOrgan: v.draggingOrgan
        };
    };
};
var tileSize = 20.0;
var tileRect = function (v) {
    return {
        x: v.x,
        y: v.y,
        width: tileSize,
        height: tileSize
    };
};
var targetNameSize = 3.0 * tileSize;
var setDirtyUI = function (t) {
    return function (v) {
        return {
            rightPaneTarget: v.rightPaneTarget,
            lockedTarget: v.lockedTarget,
            itemTarget: v.itemTarget,
            timestamp: t,
            gsTimestamp: v.gsTimestamp,
            playerAnim: v.playerAnim,
            enemyAnim: v.enemyAnim,
            itemAnim: v.itemAnim,
            highlights: v.highlights,
            audioData: v.audioData,
            audioQueue: v.audioQueue,
            draggingOrgan: v.draggingOrgan
        };
    };
};
var setDirtyGS = function (t) {
    return function (v) {
        return {
            rightPaneTarget: v.rightPaneTarget,
            lockedTarget: v.lockedTarget,
            itemTarget: v.itemTarget,
            timestamp: v.timestamp,
            gsTimestamp: t,
            playerAnim: v.playerAnim,
            enemyAnim: v.enemyAnim,
            itemAnim: v.itemAnim,
            highlights: v.highlights,
            audioData: v.audioData,
            audioQueue: v.audioQueue,
            draggingOrgan: v.draggingOrgan
        };
    };
};
var setDirtyAll = function (t) {
    return function (uis) {
        return setDirtyGS(t)(setDirtyUI(t)(uis));
    };
};
var rpTarget = function (pos) {
    return function (gs) {
        var v = GameState.getTargetAtPosition(pos)(gs);
        if (v instanceof GameState.TargetEnemy) {
            return new RPEnemy(v.value0);
        };
        if (v instanceof GameState.TargetItem) {
            return new RPItem(v.value0);
        };
        if (v instanceof GameState.TargetTerrain) {
            return new RPTerrain(v.value0);
        };
        throw new Error("Failed pattern match at UI (line 241, column 19 - line 244, column 45): " + [ v.constructor.name ]);
    };
};
var viewTarget = function (t) {
    return function (pos) {
        return function (v) {
            return function (gs) {
                var v1 = rpTarget(pos)(gs);
                if (v1 instanceof RPEnemy) {
                    return {
                        rightPaneTarget: v1,
                        lockedTarget: v.lockedTarget,
                        itemTarget: v.itemTarget,
                        timestamp: t,
                        gsTimestamp: v.gsTimestamp,
                        playerAnim: v.playerAnim,
                        enemyAnim: v.enemyAnim,
                        itemAnim: v.itemAnim,
                        highlights: v.highlights,
                        audioData: v.audioData,
                        audioQueue: v.audioQueue,
                        draggingOrgan: v.draggingOrgan
                    };
                };
                if (v1 instanceof RPItem) {
                    return {
                        rightPaneTarget: v.rightPaneTarget,
                        lockedTarget: v.lockedTarget,
                        itemTarget: v1,
                        timestamp: t,
                        gsTimestamp: v.gsTimestamp,
                        playerAnim: v.playerAnim,
                        enemyAnim: v.enemyAnim,
                        itemAnim: v.itemAnim,
                        highlights: v.highlights,
                        audioData: v.audioData,
                        audioQueue: v.audioQueue,
                        draggingOrgan: v.draggingOrgan
                    };
                };
                return toLockedTarget(t)(v);
            };
        };
    };
};
var rightPaneTiles = 9.0;
var targetBoardContainerSize = rightPaneTiles * tileSize;
var targetPadding = (rightPaneTiles - 6.0) * tileSize;
var rightPaneBorder = 1.0;
var resolveAudio = function (path) {
    return function (v) {
        return Extra_Prelude.unsafeFromJust(Data_Map_Internal.lookup(Data_Ord.ordString)(path)(v.audioData));
    };
};
var rectPos = function (v) {
    return {
        x: v.x,
        y: v.y
    };
};
var lockTarget = function (t) {
    return function (pos) {
        return function (v) {
            return function (gs) {
                var target = rpTarget(pos)(gs);
                return {
                    rightPaneTarget: target,
                    lockedTarget: target,
                    itemTarget: v.itemTarget,
                    timestamp: t,
                    gsTimestamp: v.gsTimestamp,
                    playerAnim: v.playerAnim,
                    enemyAnim: v.enemyAnim,
                    itemAnim: v.itemAnim,
                    highlights: v.highlights,
                    audioData: v.audioData,
                    audioQueue: v.audioQueue,
                    draggingOrgan: v.draggingOrgan
                };
            };
        };
    };
};
var loadAudioData = function (paths) {
    return function __do() {
        var audios = Data_Traversable.traverse(Data_Traversable.traversableArray)(Effect.applicativeEffect)(Framework_Audio.loadAudio)(paths)();
        return Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray)(Data_Array.zip(paths)(audios));
    };
};
var leftPaneTiles = 6.0;
var leftPaneBorder = 1.0;
var leftPaneSize = leftPaneTiles * tileSize + leftPaneBorder;
var inRect = function (v) {
    return function (r) {
        var y = v.y - r.y;
        var x = v.x - r.x;
        var $123 = x >= 0.0 && (x <= r.width && (y >= 0.0 && y <= r.height));
        if ($123) {
            return new Data_Maybe.Just({
                x: x,
                y: y
            });
        };
        return Data_Maybe.Nothing.value;
    };
};
var locateBlock = function (p) {
    return function (f) {
        return function (rect) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(inRect(p)(rect))(function (v) {
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(f({
                    x: Data_Int.floor(v.x / tileSize),
                    y: Data_Int.floor(v.y / tileSize)
                }));
            });
        };
    };
};
var imagePaths = [ "player.png", "ButtonPushed.png", "ButtonUnpushed.png", "ground.png", "heal.png", "heart.png", "injuredheart.png", "player.png", "roomba.png", "wall.png", "exit.png", "Heart4.png", "Heart4injured.png", "placeholder.png", "doorclosed.png", "dooropen.png", "drone.png", "Eye1.png", "Eye1Hurt.png", "Eye2.png", "Eye2Hurt.png", "Eye3.png", "Eye3Hurt.png", "Eye4.png", "Eye4Hurt.png", "Eye5.png", "Eye5Hurt.png", "Armor5.png", "Armor5Hurt.png", "weapon.png", "Fridge.png", "Battlebot1.png" ];
var hightlightRect = function (r) {
    return function (v) {
        return {
            rightPaneTarget: v.rightPaneTarget,
            lockedTarget: v.lockedTarget,
            itemTarget: v.itemTarget,
            timestamp: v.timestamp,
            gsTimestamp: v.gsTimestamp,
            playerAnim: v.playerAnim,
            enemyAnim: v.enemyAnim,
            itemAnim: v.itemAnim,
            highlights: Data_Array.cons(r)(v.highlights),
            audioData: v.audioData,
            audioQueue: v.audioQueue,
            draggingOrgan: v.draggingOrgan
        };
    };
};
var getTarget = function (v) {
    if (v.rightPaneTarget instanceof RPEnemy) {
        return new Data_Maybe.Just(v.rightPaneTarget.value0);
    };
    return Data_Maybe.Nothing.value;
};
var getDir = function (v) {
    if (v === "ArrowLeft") {
        return new Data_Maybe.Just(Framework_Direction.left);
    };
    if (v === "ArrowRight") {
        return new Data_Maybe.Just(Framework_Direction.right);
    };
    if (v === "ArrowDown") {
        return new Data_Maybe.Just(Framework_Direction.down);
    };
    if (v === "ArrowUp") {
        return new Data_Maybe.Just(Framework_Direction.up);
    };
    if (v === "KeyH") {
        return new Data_Maybe.Just(Framework_Direction.left);
    };
    if (v === "KeyJ") {
        return new Data_Maybe.Just(Framework_Direction.down);
    };
    if (v === "KeyK") {
        return new Data_Maybe.Just(Framework_Direction.up);
    };
    if (v === "KeyL") {
        return new Data_Maybe.Just(Framework_Direction.right);
    };
    if (v === "KeyY") {
        return new Data_Maybe.Just(Framework_Direction.upLeft);
    };
    if (v === "KeyU") {
        return new Data_Maybe.Just(Framework_Direction.upRight);
    };
    if (v === "KeyB") {
        return new Data_Maybe.Just(Framework_Direction.downLeft);
    };
    if (v === "KeyN") {
        return new Data_Maybe.Just(Framework_Direction.downRight);
    };
    if (v === "NumPad1") {
        return new Data_Maybe.Just(Framework_Direction.downLeft);
    };
    if (v === "NumPad2") {
        return new Data_Maybe.Just(Framework_Direction.down);
    };
    if (v === "NumPad3") {
        return new Data_Maybe.Just(Framework_Direction.downRight);
    };
    if (v === "NumPad4") {
        return new Data_Maybe.Just(Framework_Direction.left);
    };
    if (v === "NumPad6") {
        return new Data_Maybe.Just(Framework_Direction.right);
    };
    if (v === "NumPad7") {
        return new Data_Maybe.Just(Framework_Direction.upLeft);
    };
    if (v === "NumPad8") {
        return new Data_Maybe.Just(Framework_Direction.up);
    };
    if (v === "NumPad9") {
        return new Data_Maybe.Just(Framework_Direction.upRight);
    };
    if (v === "KeyZ") {
        return new Data_Maybe.Just(Framework_Direction.downLeft);
    };
    if (v === "KeyX") {
        return new Data_Maybe.Just(Framework_Direction.down);
    };
    if (v === "KeyC") {
        return new Data_Maybe.Just(Framework_Direction.downRight);
    };
    if (v === "KeyA") {
        return new Data_Maybe.Just(Framework_Direction.left);
    };
    if (v === "KeyD") {
        return new Data_Maybe.Just(Framework_Direction.right);
    };
    if (v === "KeyQ") {
        return new Data_Maybe.Just(Framework_Direction.upLeft);
    };
    if (v === "KeyW") {
        return new Data_Maybe.Just(Framework_Direction.up);
    };
    if (v === "KeyE") {
        return new Data_Maybe.Just(Framework_Direction.upRight);
    };
    return Data_Maybe.Nothing.value;
};
var getAudio = function (v) {
    var samples = Data_Array.filter(function (v1) {
        return v1.delay >= 0.0;
    })(Data_Functor.mapFlipped(Data_Functor.functorArray)(v.audioQueue)(function (v1) {
        return {
            audio: resolveAudio(v1.file)(v),
            delay: Data_Newtype.un(Data_Time_Duration.newtypeMilliseconds)(Data_Time_Duration.Milliseconds)(Data_DateTime_Instant.unInstant(v1.time)) - Data_Newtype.un(Data_Time_Duration.newtypeMilliseconds)(Data_Time_Duration.Milliseconds)(Data_DateTime_Instant.unInstant(v.timestamp))
        };
    }));
    return {
        samples: samples,
        timestamp: new Data_Maybe.Just(v.timestamp)
    };
};
var fromGrid = function (p) {
    return Data_Functor.mapFlipped(Extra_Math.functorVector)(p)(function (x) {
        return Extra_Math.toNumber(Extra_Math.realInt)(x) * tileSize;
    });
};
var eqrp = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof RPEnemy && y instanceof RPEnemy) {
            return x.value0 === y.value0;
        };
        if (x instanceof RPItem && y instanceof RPItem) {
            return x.value0 === y.value0;
        };
        if (x instanceof RPTerrain && y instanceof RPTerrain) {
            return Data_Eq.eq(Data_Terrain.terrainEq)(x.value0)(y.value0);
        };
        if (x instanceof RPNoTarget && y instanceof RPNoTarget) {
            return true;
        };
        return false;
    };
});
var enqueueAudio = function (time) {
    return function (file) {
        return function (v) {
            return {
                rightPaneTarget: v.rightPaneTarget,
                lockedTarget: v.lockedTarget,
                itemTarget: v.itemTarget,
                timestamp: time,
                gsTimestamp: v.gsTimestamp,
                playerAnim: v.playerAnim,
                enemyAnim: v.enemyAnim,
                itemAnim: v.itemAnim,
                highlights: v.highlights,
                audioData: v.audioData,
                audioQueue: Data_Array.cons({
                    time: time,
                    file: file
                })(v.audioQueue),
                draggingOrgan: v.draggingOrgan
            };
        };
    };
};
var uiEvent = function (t) {
    return function (v) {
        return function (v1) {
            if (v instanceof GameState.PlayerMoved) {
                var backwards = Data_Functor.map(Extra_Math.functorVector)(Data_Semiring.mul(Data_Semiring.semiringNumber)(tileSize))(Framework_Direction.dirVector(Data_Ring.ringNumber)(Framework_Direction.opposite(v.value0)));
                var fade = Animation_Util.reverseSlide(t)(300.0)(backwards);
                return {
                    rightPaneTarget: v1.rightPaneTarget,
                    lockedTarget: v1.lockedTarget,
                    itemTarget: v1.itemTarget,
                    timestamp: v1.timestamp,
                    gsTimestamp: v1.gsTimestamp,
                    playerAnim: Animation_Core.prune(t)(Data_Semiring.add(Animation_Core.animatingSemiring(Extra_Math.semiringVector(Data_Semiring.semiringNumber)))(v1.playerAnim)(fade)),
                    enemyAnim: v1.enemyAnim,
                    itemAnim: v1.itemAnim,
                    highlights: v1.highlights,
                    audioData: v1.audioData,
                    audioQueue: v1.audioQueue,
                    draggingOrgan: v1.draggingOrgan
                };
            };
            if (v instanceof GameState.EnemyMoved) {
                var realVec = Data_Functor.map(Extra_Math.functorVector)((function () {
                    var $289 = Data_Semiring.mul(Data_Semiring.semiringNumber)(tileSize);
                    var $290 = Extra_Math.toNumber(Extra_Math.realInt);
                    return function ($291) {
                        return $289($290($291));
                    };
                })())(v.value1);
                var fade = Animation_Util.reverseSlide(t)(300.0)(Data_Ring.negate(Extra_Math.ringVector(Data_Ring.ringNumber))(realVec));
                var cleanedAnim = Data_Map_Internal.filter(Data_Ord.ordInt)((function () {
                    var $292 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
                    var $293 = Animation_Core.isStatic(t);
                    return function ($294) {
                        return $292($293($294));
                    };
                })())(Data_Functor.map(Data_Map_Internal.functorMap)(Animation_Core.prune(t))(v1.enemyAnim));
                var anim = (function () {
                    var v2 = Data_Map_Internal.lookup(Data_Ord.ordInt)(v.value0)(cleanedAnim);
                    if (v2 instanceof Data_Maybe.Nothing) {
                        return fade;
                    };
                    if (v2 instanceof Data_Maybe.Just) {
                        return Data_Semiring.add(Animation_Core.animatingSemiring(Extra_Math.semiringVector(Data_Semiring.semiringNumber)))(v2.value0)(fade);
                    };
                    throw new Error("Failed pattern match at UI (line 438, column 14 - line 440, column 37): " + [ v2.constructor.name ]);
                })();
                return {
                    rightPaneTarget: v1.rightPaneTarget,
                    lockedTarget: v1.lockedTarget,
                    itemTarget: v1.itemTarget,
                    timestamp: v1.timestamp,
                    gsTimestamp: v1.gsTimestamp,
                    playerAnim: v1.playerAnim,
                    enemyAnim: Data_Map_Internal.insert(Data_Ord.ordInt)(v.value0)(anim)(cleanedAnim),
                    itemAnim: v1.itemAnim,
                    highlights: v1.highlights,
                    audioData: v1.audioData,
                    audioQueue: v1.audioQueue,
                    draggingOrgan: v1.draggingOrgan
                };
            };
            if (v instanceof GameState.PlayerAttacked) {
                return enqueueAudio(t)("pew1.mp3")(v1);
            };
            if (v instanceof GameState.EnemyDied) {
                return enqueueAudio(t)("Clang1.mp3")(v1);
            };
            if (v instanceof GameState.EnemyAttacked) {
                return enqueueAudio(t)("Taser1.mp3")(v1);
            };
            if (v instanceof GameState.ItemUsed) {
                return setDirtyUI(t)(v1);
            };
            return v1;
        };
    };
};
var updateUIState = function (t) {
    return function (v) {
        return function (v1) {
            return function (v2) {
                if (v1 instanceof Data_Either.Left && v1.value0 instanceof GameState.FailedAction) {
                    var bump = Animation_Util.bump(t)(200.0)(Framework_Direction.move(Data_Ring.ringNumber)(v1.value0.value0)(Data_Semiring.zero(Extra_Math.semiringVector(Data_Semiring.semiringNumber))));
                    return UIState({
                        rightPaneTarget: v2.rightPaneTarget,
                        lockedTarget: v2.lockedTarget,
                        itemTarget: v2.itemTarget,
                        timestamp: t,
                        gsTimestamp: v2.gsTimestamp,
                        playerAnim: Animation_Core.prune(t)(Data_Semiring.add(Animation_Core.animatingSemiring(Extra_Math.semiringVector(Data_Semiring.semiringNumber)))(v2.playerAnim)(bump)),
                        enemyAnim: v2.enemyAnim,
                        itemAnim: v2.itemAnim,
                        highlights: v2.highlights,
                        audioData: v2.audioData,
                        audioQueue: v2.audioQueue,
                        draggingOrgan: v2.draggingOrgan
                    });
                };
                if (v1 instanceof Data_Either.Right) {
                    var ui = {
                        rightPaneTarget: v2.rightPaneTarget,
                        lockedTarget: v2.lockedTarget,
                        itemTarget: v2.itemTarget,
                        timestamp: t,
                        gsTimestamp: t,
                        playerAnim: v2.playerAnim,
                        enemyAnim: v2.enemyAnim,
                        itemAnim: v2.itemAnim,
                        highlights: v2.highlights,
                        audioData: v2.audioData,
                        audioQueue: v2.audioQueue,
                        draggingOrgan: v2.draggingOrgan
                    };
                    return Data_Foldable.foldr(Data_Foldable.foldableArray)(uiEvent(t))(ui)(v1.value0.events);
                };
                if (v1 instanceof Data_Either.Left) {
                    return v2;
                };
                throw new Error("Failed pattern match at UI (line 388, column 1 - line 393, column 13): " + [ t.constructor.name, v.constructor.name, v1.constructor.name, v2.constructor.name ]);
            };
        };
    };
};
var emptyAudioQueue = [  ];
var cutUp = function (d) {
    return function (r) {
        return {
            height: d,
            width: r.width,
            x: r.x,
            y: r.y
        };
    };
};
var cutRight = function (d) {
    return function (r) {
        return {
            height: r.height,
            width: r.width - d,
            x: r.x + d,
            y: r.y
        };
    };
};
var cutLeft = function (d) {
    return function (r) {
        return {
            height: r.height,
            width: d,
            x: r.x,
            y: r.y
        };
    };
};
var cutDown = function (d) {
    return function (r) {
        return {
            height: r.height - d,
            width: r.width,
            x: r.x,
            y: r.y + d
        };
    };
};
var clearHighlights = function (v) {
    return {
        rightPaneTarget: v.rightPaneTarget,
        lockedTarget: v.lockedTarget,
        itemTarget: v.itemTarget,
        timestamp: v.timestamp,
        gsTimestamp: v.gsTimestamp,
        playerAnim: v.playerAnim,
        enemyAnim: v.enemyAnim,
        itemAnim: v.itemAnim,
        highlights: [  ],
        audioData: v.audioData,
        audioQueue: v.audioQueue,
        draggingOrgan: v.draggingOrgan
    };
};
var clearAudio = function (v) {
    return {
        rightPaneTarget: v.rightPaneTarget,
        lockedTarget: v.lockedTarget,
        itemTarget: v.itemTarget,
        timestamp: v.timestamp,
        gsTimestamp: v.gsTimestamp,
        playerAnim: v.playerAnim,
        enemyAnim: v.enemyAnim,
        itemAnim: v.itemAnim,
        highlights: v.highlights,
        audioData: v.audioData,
        audioQueue: emptyAudioQueue,
        draggingOrgan: v.draggingOrgan
    };
};
var nextUI = function (t) {
    return function (gs) {
        return function (a) {
            return function (uis) {
                return updateUIState(t)(gs)(a)(clearAudio(uis));
            };
        };
    };
};
var centerPaneTiles = Extra_Math.toNumber(Extra_Math.realInt)(Data_Terrain.arena.width);
var screen = {
    x: 0.0,
    y: 0.0,
    width: (leftPaneTiles + centerPaneTiles + rightPaneTiles) * tileSize + leftPaneBorder + rightPaneBorder,
    height: verticalTiles * tileSize
};
var leftPaneRect = cutLeft(leftPaneSize)(screen);
var playerBoardRect = cutUp(6.0 * tileSize)(cutDown(tileSize + 1.0)(leftPaneRect));
var targetDimensions = {
    width: screen.width,
    height: screen.height
};
var centerPaneSize = centerPaneTiles * tileSize;
var rightPaneRect = cutRight(leftPaneSize + centerPaneSize)(screen);
var targetBoardContainerRect = cutUp(targetBoardContainerSize)(cutDown(targetNameSize)(rightPaneRect));
var targetBoardRect = {
    x: targetBoardContainerRect.x + 2.0,
    y: targetBoardContainerRect.y + tileSize + 2.0,
    width: 6.0 * tileSize,
    height: 6.0 * tileSize
};
var targetNameRect = cutUp(targetNameSize)(rightPaneRect);
var centerPaneRect = cutLeft(centerPaneSize)(cutRight(leftPaneSize)(screen));
var locate = function (p) {
    return Data_Maybe.fromMaybe(Other.value)(Control_Alt.alt(Data_Maybe.altMaybe)(Control_Alt.alt(Data_Maybe.altMaybe)(locateBlock(p)(CenterPane.create)(centerPaneRect))(locateBlock(p)(TargetBoard.create)(targetBoardRect)))(locateBlock(p)(PlayerBoard.create)(playerBoardRect)));
};
var organDragLoc = function (startPos) {
    return function (offset) {
        var start = Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(fromGrid(startPos))({
            x: tileSize / 2.0,
            y: tileSize / 2.0
        }))(rectPos(centerPaneRect));
        var end = Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(start)(offset);
        var v = locate(end);
        if (v instanceof PlayerBoard) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    };
};
var toRect = function (v) {
    if (v instanceof TargetBoard) {
        return Data_Maybe.Just.create(tileRect(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(fromGrid(v.value0))(rectPos(targetBoardRect))));
    };
    if (v instanceof CenterPane) {
        return Data_Maybe.Just.create(tileRect(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(fromGrid(v.value0))(rectPos(centerPaneRect))));
    };
    if (v instanceof PlayerBoard) {
        return Data_Maybe.Just.create(tileRect(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(fromGrid(v.value0))(rectPos(playerBoardRect))));
    };
    if (v instanceof Other) {
        return Data_Maybe.Nothing.value;
    };
    throw new Error("Failed pattern match at UI (line 697, column 1 - line 697, column 40): " + [ v.constructor.name ]);
};
var highlight = function (p) {
    return function (uis) {
        return Data_Maybe.fromMaybe(uis)(Control_Bind.bind(Data_Maybe.bindMaybe)(toRect(p))(function (rect) {
            return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(hightlightRect(rect)(uis));
        }));
    };
};
var highlights = function (ps) {
    return function (uis) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (u) {
            return function (p) {
                return highlight(p)(u);
            };
        })(uis)(ps);
    };
};
var dragOrgan = function (t) {
    return function (ptrId) {
        return function (organ) {
            return function (initialClickPos) {
                return function (uis) {
                    return function (gs) {
                        var stop = function (v) {
                            return {
                                rightPaneTarget: v.rightPaneTarget,
                                lockedTarget: v.lockedTarget,
                                itemTarget: v.itemTarget,
                                timestamp: v.timestamp,
                                gsTimestamp: v.gsTimestamp,
                                playerAnim: v.playerAnim,
                                enemyAnim: v.enemyAnim,
                                itemAnim: v.itemAnim,
                                highlights: v.highlights,
                                audioData: v.audioData,
                                audioQueue: v.audioQueue,
                                draggingOrgan: Data_Maybe.Nothing.value
                            };
                        };
                        var setOffset = function (offset) {
                            return function (v) {
                                return {
                                    rightPaneTarget: v.rightPaneTarget,
                                    lockedTarget: v.lockedTarget,
                                    itemTarget: v.itemTarget,
                                    timestamp: v.timestamp,
                                    gsTimestamp: v.gsTimestamp,
                                    playerAnim: v.playerAnim,
                                    enemyAnim: v.enemyAnim,
                                    itemAnim: v.itemAnim,
                                    highlights: v.highlights,
                                    audioData: v.audioData,
                                    audioQueue: v.audioQueue,
                                    draggingOrgan: new Data_Maybe.Just({
                                        organ: organ,
                                        offset: offset
                                    })
                                };
                            };
                        };
                        var setDirty = function (v) {
                            return {
                                rightPaneTarget: v.rightPaneTarget,
                                lockedTarget: v.lockedTarget,
                                itemTarget: v.itemTarget,
                                timestamp: v.timestamp,
                                gsTimestamp: t,
                                playerAnim: v.playerAnim,
                                enemyAnim: v.enemyAnim,
                                itemAnim: v.itemAnim,
                                highlights: v.highlights,
                                audioData: v.audioData,
                                audioQueue: v.audioQueue,
                                draggingOrgan: v.draggingOrgan
                            };
                        };
                        var go = function (u) {
                            return Control_Bind.bind(Control_Monad_Free.freeBind)(Framework_UI.input(u))(function (v) {
                                var nextU = clearHighlights(u);
                                if (v.value instanceof Input.PointerMove) {
                                    var offset = Data_Ring.sub(Extra_Math.ringVector(Data_Ring.ringNumber))(v.value.value0.location)(initialClickPos);
                                    var newUIS = Data_Maybe.fromMaybe(nextU)(Control_Bind.bind(Data_Maybe.bindMaybe)(organDragLoc(organ.value1)(offset))(function (l) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(GameState.canInstallOrgan(l)(organ)(gs)))(function () {
                                            return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(highlights(Data_Functor.map(Data_Functor.functorArray)(PlayerBoard.create)(Data_Board.extent(organ.value0)(l)))(nextU));
                                        });
                                    }));
                                    return go(setOffset(offset)(newUIS));
                                };
                                if (v.value instanceof Input.PointerUp) {
                                    var $193 = v.value.value0.pointerId === ptrId;
                                    if ($193) {
                                        return Control_Applicative.pure(Control_Monad_Free.freeApplicative)({
                                            time: v.time,
                                            v: Data_Ring.sub(Extra_Math.ringVector(Data_Ring.ringNumber))(v.value.value0.location)(initialClickPos)
                                        });
                                    };
                                    return Control_Applicative.pure(Control_Monad_Free.freeApplicative)({
                                        time: v.time,
                                        v: Data_Semiring.zero(Extra_Math.semiringVector(Data_Semiring.semiringNumber))
                                    });
                                };
                                return go(nextU);
                            });
                        };
                        return go(enqueueAudio(t)("Puip1.mp3")(setOffset(Data_Semiring.zero(Extra_Math.semiringVector(Data_Semiring.semiringNumber)))(setDirty(uis))));
                    };
                };
            };
        };
    };
};
var audioPaths = [ "Clang1.mp3", "Organ2.mp3", "Organ3.mp3", "Puip1.mp3", "Taser1.mp3", "pew1.mp3" ];
var initUIState = function (v) {
    return function __do() {
        var audioData = loadAudioData(audioPaths)();
        return {
            rightPaneTarget: RPNoTarget.value,
            lockedTarget: RPNoTarget.value,
            itemTarget: RPNoTarget.value,
            timestamp: Extra_Prelude.unsafeFromJust(Data_DateTime_Instant.instant(0.0)),
            gsTimestamp: Extra_Prelude.unsafeFromJust(Data_DateTime_Instant.instant(0.0)),
            playerAnim: Control_Applicative.pure(Animation_Core.applicativeAnimating)(Data_Semiring.zero(Extra_Math.semiringVector(Data_Semiring.semiringNumber))),
            draggingOrgan: Data_Maybe.Nothing.value,
            enemyAnim: Data_Map_Internal.empty,
            itemAnim: Data_Map_Internal.empty,
            audioData: audioData,
            audioQueue: [  ],
            highlights: [  ]
        };
    };
};
var victoryUI = function (uis) {
    return function (v) {
        return Control_Bind.bind(Control_Monad_Free.freeBind)(Framework_UI.input(uis))(function (v1) {
            if (v1.value instanceof Input.KeyDown) {
                return doAction(GameState.StartNewGame.value)(v1.time)(setDirtyAll(v1.time)(uis))(v);
            };
            if (v1.value instanceof Input.PointerDown) {
                return doAction(GameState.StartNewGame.value)(v1.time)(setDirtyAll(v1.time)(uis))(v);
            };
            return runUI(uis)(v);
        });
    };
};
var tryInstallOrgan = function (t) {
    return function (pb) {
        return function (organ) {
            return function (uis) {
                return function (v) {
                    var $214 = GameState.canInstallOrgan(pb)(organ)(v);
                    if ($214) {
                        return audioAction("Organ2.mp3")(new GameState.InstallOrgan(organ, pb))(t)(uis)(v);
                    };
                    return runUI(uis)(v);
                };
            };
        };
    };
};
var tryAttack = function (t) {
    return function (pos) {
        return function (uis) {
            return function (gs) {
                var v = getTarget(uis);
                if (v instanceof Data_Maybe.Nothing) {
                    return runUI(uis)(gs);
                };
                if (v instanceof Data_Maybe.Just) {
                    return doAction(new GameState.Attack(pos, v.value0))(t)(uis)(gs);
                };
                throw new Error("Failed pattern match at UI (line 295, column 3 - line 297, column 54): " + [ v.constructor.name ]);
            };
        };
    };
};
var surgeryUI = function (uis) {
    return function (v) {
        return Control_Bind.bind(Control_Monad_Free.freeBind)(Framework_UI.input(uis))(function (v1) {
            if (v1.value instanceof Input.PointerDown) {
                var v2 = locate(v1.value.value0.location);
                if (v2 instanceof CenterPane) {
                    var v3 = Data_Board.organAt(v2.value0)(v.availableOrgans);
                    if (v3 instanceof Data_Maybe.Nothing) {
                        return runUI(uis)(v);
                    };
                    if (v3 instanceof Data_Maybe.Just) {
                        return Control_Bind.bind(Control_Monad_Free.freeBind)(dragOrgan(v1.time)(v1.value.value0.pointerId)(v3.value0)(v1.value.value0.location)(uis)(v))(function (v4) {
                            var newUIS = setDirtyAll(v4.time)(uis);
                            var v5 = organDragLoc(Data_Tuple.snd(v3.value0))(v4.v);
                            if (v5 instanceof Data_Maybe.Just) {
                                return tryInstallOrgan(v4.time)(v5.value0)(v3.value0)(newUIS)(v);
                            };
                            return runUI(newUIS)(v);
                        });
                    };
                    throw new Error("Failed pattern match at UI (line 164, column 14 - line 176, column 46): " + [ v3.constructor.name ]);
                };
                if (v2 instanceof PlayerBoard) {
                    var b = (function (v3) {
                        return v3.organs;
                    })(Data_Newtype.un(Data_Board.newtypeBoard)(Data_Board.Board)((function (v3) {
                        return v3.board;
                    })(Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth))));
                    var v3 = Data_Board.organAt(v2.value0)(b);
                    if (v3 instanceof Data_Maybe.Nothing) {
                        return runUI(uis)(v);
                    };
                    if (v3 instanceof Data_Maybe.Just) {
                        return audioAction("Organ3.mp3")(new GameState.RemoveOrgan(v3.value0.value1))(v1.time)(setDirtyUI(v1.time)(uis))(v);
                    };
                    throw new Error("Failed pattern match at UI (line 180, column 20 - line 184, column 53): " + [ v3.constructor.name ]);
                };
                return runUI(uis)(v);
            };
            if (v1.value instanceof Input.KeyDown) {
                return doAction(GameState.FinishSurgery.value)(v1.time)(setDirtyAll(v1.time)(uis))(v);
            };
            return runUI(uis)(v);
        });
    };
};
var runUI = function (uis) {
    return function (v) {
        var u = clearHighlights(uis);
        if (v.level instanceof GameState.Surgery) {
            return surgeryUI(u)(v);
        };
        if (v.level instanceof GameState.Regular) {
            return mapUI(u)(v);
        };
        if (v.level instanceof GameState.NewGame) {
            return newGameUI(u)(v);
        };
        if (v.level instanceof GameState.Dead) {
            return deadUI(u)(v);
        };
        if (v.level instanceof GameState.Victory) {
            return victoryUI(u)(v);
        };
        throw new Error("Failed pattern match at UI (line 120, column 3 - line 125, column 40): " + [ v.level.constructor.name ]);
    };
};
var newGameUI = function (uis) {
    return function (v) {
        return Control_Bind.bind(Control_Monad_Free.freeBind)(Framework_UI.input(uis))(function (v1) {
            if (v1.value instanceof Input.KeyDown) {
                return doAction(GameState.StartNewGame.value)(v1.time)(setDirtyAll(v1.time)(uis))(v);
            };
            if (v1.value instanceof Input.PointerDown) {
                return doAction(GameState.StartNewGame.value)(v1.time)(setDirtyAll(v1.time)(uis))(v);
            };
            return runUI(uis)(v);
        });
    };
};
var mapUI = function (v) {
    return function (v1) {
        return Control_Bind.bind(Control_Monad_Free.freeBind)(Framework_UI.input(v))(function (v2) {
            if (v2.value instanceof Input.KeyDown) {
                var v3 = getDir(v2.value.value0);
                if (v3 instanceof Data_Maybe.Nothing) {
                    return runUI(v)(v1);
                };
                if (v3 instanceof Data_Maybe.Just) {
                    return doAction(new GameState.Move(v3.value0))(v2.time)(v)(v1);
                };
                throw new Error("Failed pattern match at UI (line 131, column 23 - line 133, column 51): " + [ v3.constructor.name ]);
            };
            if (v2.value instanceof Input.PointerDown) {
                var v3 = locate(v2.value.value0.location);
                if (v3 instanceof CenterPane) {
                    var newUI = lockTarget(v2.time)(v3.value0)(v)(v1);
                    return runUI(newUI)(v1);
                };
                if (v3 instanceof TargetBoard) {
                    return tryAttack(v2.time)(v3.value0)(v)(v1);
                };
                return runUI(v)(v1);
            };
            if (v2.value instanceof Input.PointerMove) {
                var v3 = locate(v2.value.value0.location);
                if (v3 instanceof CenterPane) {
                    var newUI = viewTarget(v2.time)(v3.value0)(v)(v1);
                    return runUI(newUI)(v1);
                };
                var $268 = Data_Eq.notEq(eqrp)(v.lockedTarget)(v.rightPaneTarget);
                if ($268) {
                    var newUI = toLockedTarget(v2.time)(v);
                    return runUI(newUI)(v1);
                };
                return runUI(v)(v1);
            };
            return runUI(v)(v1);
        });
    };
};
var doAction = function (action) {
    return function (time) {
        return function (uis) {
            return function (gs) {
                return Control_Bind.bind(Control_Monad_Free.freeBind)(Framework_UI.action(action))(function (result) {
                    var uis$prime = nextUI(time)(gs)(result)(uis);
                    var gs$prime = Data_Either.either(Data_Function["const"](gs))(Control_Category.identity(Control_Category.categoryFn))(result);
                    return runUI(uis$prime)(gs$prime);
                });
            };
        };
    };
};
var deadUI = function (uis) {
    return function (v) {
        return Control_Bind.bind(Control_Monad_Free.freeBind)(Framework_UI.input(uis))(function (v1) {
            if (v1.value instanceof Input.KeyDown) {
                return doAction(GameState.StartNewGame.value)(v1.time)(setDirtyAll(v1.time)(uis))(v);
            };
            if (v1.value instanceof Input.PointerDown) {
                return doAction(GameState.StartNewGame.value)(v1.time)(setDirtyAll(v1.time)(uis))(v);
            };
            return runUI(uis)(v);
        });
    };
};
var audioAction = function (audio) {
    return function (action) {
        return function (time) {
            return function (uis) {
                return function (gs) {
                    return Control_Bind.bind(Control_Monad_Free.freeBind)(Framework_UI.action(action))(function (result) {
                        var uis$prime = enqueueAudio(time)(audio)(nextUI(time)(gs)(result)(uis));
                        var gs$prime = Data_Either.either(Data_Function["const"](gs))(Control_Category.identity(Control_Category.categoryFn))(result);
                        return runUI(uis$prime)(gs$prime);
                    });
                };
            };
        };
    };
};
var tryRemoveOrgan = function (t) {
    return function (p) {
        return function (uis) {
            return function (v) {
                var b = (function (v1) {
                    return v1.organs;
                })(Data_Newtype.un(Data_Board.newtypeBoard)(Data_Board.Board)((function (v1) {
                    return v1.board;
                })(Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth))));
                var v1 = Data_Board.organAt(p)(b);
                if (v1 instanceof Data_Maybe.Nothing) {
                    return runUI(uis)(v);
                };
                if (v1 instanceof Data_Maybe.Just) {
                    return audioAction("Organ3.mp3")(new GameState.RemoveOrgan(v1.value0.value1))(t)(setDirtyUI(t)(uis))(v);
                };
                throw new Error("Failed pattern match at UI (line 309, column 7 - line 313, column 34): " + [ v1.constructor.name ]);
            };
        };
    };
};
module.exports = {
    UIState: UIState,
    RPEnemy: RPEnemy,
    RPItem: RPItem,
    RPTerrain: RPTerrain,
    RPNoTarget: RPNoTarget,
    initUIState: initUIState,
    runUI: runUI,
    mapUI: mapUI,
    surgeryUI: surgeryUI,
    dragOrgan: dragOrgan,
    organDragLoc: organDragLoc,
    rpTarget: rpTarget,
    viewTarget: viewTarget,
    lockTarget: lockTarget,
    toLockedTarget: toLockedTarget,
    getTarget: getTarget,
    doAction: doAction,
    tryAttack: tryAttack,
    tryInstallOrgan: tryInstallOrgan,
    tryRemoveOrgan: tryRemoveOrgan,
    audioAction: audioAction,
    newGameUI: newGameUI,
    deadUI: deadUI,
    victoryUI: victoryUI,
    setDirtyGS: setDirtyGS,
    setDirtyUI: setDirtyUI,
    setDirtyAll: setDirtyAll,
    nextUI: nextUI,
    updateUIState: updateUIState,
    uiEvent: uiEvent,
    getDir: getDir,
    cutLeft: cutLeft,
    cutRight: cutRight,
    cutUp: cutUp,
    cutDown: cutDown,
    screen: screen,
    leftPaneSize: leftPaneSize,
    leftPaneRect: leftPaneRect,
    playerBoardRect: playerBoardRect,
    centerPaneSize: centerPaneSize,
    centerPaneRect: centerPaneRect,
    rightPaneRect: rightPaneRect,
    targetNameSize: targetNameSize,
    targetNameRect: targetNameRect,
    targetBoardContainerSize: targetBoardContainerSize,
    targetBoardContainerRect: targetBoardContainerRect,
    targetPadding: targetPadding,
    targetBoardRect: targetBoardRect,
    targetDimensions: targetDimensions,
    leftPaneTiles: leftPaneTiles,
    leftPaneBorder: leftPaneBorder,
    rightPaneBorder: rightPaneBorder,
    centerPaneTiles: centerPaneTiles,
    rightPaneTiles: rightPaneTiles,
    verticalTiles: verticalTiles,
    tileSize: tileSize,
    TargetBoard: TargetBoard,
    CenterPane: CenterPane,
    PlayerBoard: PlayerBoard,
    Other: Other,
    inRect: inRect,
    locate: locate,
    locateBlock: locateBlock,
    loadAudioData: loadAudioData,
    resolveAudio: resolveAudio,
    emptyAudioQueue: emptyAudioQueue,
    clearAudio: clearAudio,
    enqueueAudio: enqueueAudio,
    getAudio: getAudio,
    rectPos: rectPos,
    fromGrid: fromGrid,
    tileRect: tileRect,
    toRect: toRect,
    clearHighlights: clearHighlights,
    highlight: highlight,
    highlights: highlights,
    hightlightRect: hightlightRect,
    imagePaths: imagePaths,
    audioPaths: audioPaths,
    eqrp: eqrp
};
